// extracted by mini-css-extract-plugin
module.exports = {"spinner":"styles_spinner__2Vb-x","doubleBounce1":"styles_doubleBounce1__2kCMV","doubleBounce2":"styles_doubleBounce2__1JN_S","sk-bounce":"styles_sk-bounce__3zKSE"};